<template>
  <tr class="line-item free-sample">
    <td class="cart-item-image hidden-xs">
      <a :href="productUrl">
        <img :src="imageUrl" width="100" height="100" />
      </a>
    </td>
    <td class="cart-item-description">
      <free-sample-select
        :selected-sample-id="variantId"
        :disabled="updating"
        @change="updateFreeSample"
      />
    </td>
    <td class="cart-item-price hidden-xs">
      {{ price }}
    </td>
    <td class="cart-item-quantity">
      1
    </td>
    <td class="cart-item-total">
      Free
    </td>
    <td class="cart-item-delete">
      <a @click.prevent="remove">
        <span class="glyphicon glyphicon-minus-sign" />
      </a>
    </td>
  </tr>
</template>

<script>
  import axios from 'axios'
  import FreeSampleSelect from './free-sample-select'

  export default {
    components: {
      FreeSampleSelect
    },
    props: {
      lineItem: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        productUrl: this.lineItem.product_url,
        imageUrl: this.lineItem.variant.image_url,
        variantId: this.lineItem.variant.id,
        price: this.lineItem.display_price,
        updating: false
      }
    },
    methods: {
      remove() {
        this.updating = true
        axios
          .delete("/cs/api/free_sample")
          .then(() => this.$emit('removed'))
          // eslint-disable-next-line no-alert
          .catch((error) => alert(error))
          .finally(() => {
            this.updating = false
          })
      },
      updateFreeSample(variantId) {
        this.updating = true
        axios.patch("/cs/api/free_sample", {
          variant_id: variantId
        }).then((response) => {
          const lineItem = response.data.line_item

          this.productUrl = lineItem.product_url
          this.imageUrl = lineItem.variant.image_url
          this.variantId = lineItem.variant.id
          this.price = lineItem.display_price
        })
          // eslint-disable-next-line no-alert
          .catch((error) => alert(error))
          .finally(() => {
            this.updating = false
          })
      }
    }
  }
</script>
